/**
 * Shell copy for `src/ui` (keys: `shell.ui.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  card: {
    progress: 'Progress',
  },
  confirm: {
    confirm: 'Confirm?',
    confirmation: 'Confirmation',
    cancel: 'Cancel',
    confirm2: 'Confirm',
  },
  dataGrid: {
    labelMinimum: '{{label}} minimum',
    labelMaximum: '{{label}} maximum',
    labelFrom: '{{label}} from',
    search: 'Search…',
    noResults: 'No results.',
    filters: 'Filters',
    displayDensity: 'Display density',
    comfortable: 'Comfortable',
    compact: 'Compact',
    searchSearch: 'Search: “{{search}}”',
    sortVV2: 'Sort: {{v}} {{v2}}',
    reset: 'Reset',
    activeFilterS: 'active filter(s)',
    tryAgain: 'Try again',
    selectAll: 'Select all',
    sort: 'Sort',
    selectTheRow: 'Select the row',
    loading: 'Loading…',
    select: 'Select',
    rangetoOfTotalrows: '–{{rangeTo}} of {{totalRows}}',
    perPage: 'Per page',
    rowsPerPage: 'Rows per page',
    firstPage: 'First page',
    previousPage: 'Previous page',
    nextPage: 'Next page',
    lastPage: 'Last page',
    removeLabel: 'Remove {{label}}',
    filterLabel: 'Filter {{label}}',
    all: 'All',
    min: 'min',
    max: 'max',
    labelUpTo: '{{label}} up to',
    contains: 'Contains…',
    columns: 'Columns',
    displayedColumns: 'Displayed columns',
    moveVLeft: 'Move {{v}} left',
    moveVRight: 'Move {{v}} right',
  },
  metrics: {
    pctPercent: '{{pct}} percent',
    progress: 'Progress',
    trend: 'Trend',
  },
  modal: {
    close: 'Close',
  },
  responsiveTable: {
    noResults: 'No results.',
    selectAll: 'Select all',
    selectTheRow: 'Select the row',
    select: 'Select',
  },
  themePicker: {
    themeSystem: 'Theme: System',
    themeLight: 'Theme: Light',
    themeDark: 'Theme: Dark',
    labelToggle: '{{label}}. Toggle.',
    accentColorLabel: 'Accent color: {{label}}',
    accentColor: 'Accent color',
  },
  toast: {
    success: 'Success',
    error: 'Error',
    information: 'Information',
    notifications: 'Notifications',
    closeTheNotification: 'Close the notification',
  },
};

export default en;
